export default "__VITE_ASSET__pqV88wThNyZ88jn985tgAA__";